import { atom } from 'jotai';

export const usersAtom = atom();
export const rawUsersAtom = atom();

